'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FAQ_ACCORDION_SELECTOR = exports.FAQ_TEMPLATE_CONTAINER = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _Accordion = require('../objects/content/Accordion');

var _Parallax = require('../objects/parallax/Parallax');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 *  Faq Template Scripts
 *    Scripts that are only meant to run on the Faq Template.
 *
 *  Version:
 *    1.0.0 - 2020/05/14
 */

var FAQ_TEMPLATE_CONTAINER = exports.FAQ_TEMPLATE_CONTAINER = '[data-faq-template]';
var FAQ_ACCORDION_SELECTOR = exports.FAQ_ACCORDION_SELECTOR = '[data-faq-accordion]';

var FaqTemplate = function FaqTemplate(container) {
  (0, _classCallCheck3.default)(this, FaqTemplate);


  var accordionElem = container.find(FAQ_ACCORDION_SELECTOR);

  if (accordionElem.length) this.accordion = new _Accordion.Accordion(accordionElem);

  this.factors = [-0.5];
  (0, _Parallax.parallax)(container, this.factors);
};

$(document).ready($(FAQ_TEMPLATE_CONTAINER).each(function (i, e) {
  return new FaqTemplate($(e));
}));